export const CUSTOMER_PORTAL_API_HEADER_KEY = 'X-ReqCu';
export const ALLOWED_MANUAL_COMMUNICATION_TEMPLATE = 'Current Statement';